<mat-card class="fitContent">
    <mat-card-subtitle>{{house.description_line1}}</mat-card-subtitle>
    <mat-card-subtitle>{{house.description_line2}}</mat-card-subtitle>
    <mat-card-content>
        <a mat-button color="primary" [href]="getUrlFromHouseUUID()" target="_blank">Ver <mat-icon>visibility</mat-icon></a>
    </mat-card-content>
</mat-card>
